import "./style.css";
import Modal from "react-bootstrap/Modal";
import config from "../../config";

function ExpenseCategoryView(props) { 
  return (
    <>
      <Modal.Header closeButton><h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">View Expense Category</h4></Modal.Header>
      <div className="container-fluid p-4" id="expcatAdd">
      <div className="row gy-3">
          <div className="col-md-6">
            <label htmlFor="exp_cat_name">
              Expense Category Name 
            </label>
            <input
              disabled
              type="text"
              className="form-control"
              id="exp_cat_name"
              value={props.id?.exp_cat_name}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="exp_cat_type">
              Expense Category Type 
            </label>
            <select
              type="text"
              className="form-control"
              id="exp_cat_type"
              disabled
              value={props.id?.exp_cat_type}
              >
              <option value="" hidden>
                N/A
              </option>
              {config.expenseCategories.map((list) => (
                <>
                  <option value={list.value}>{list.label}</option>
                </>
              ))}
            </select>
          </div>
          <div className="col-12 mt-4">         
            <button
                type="button"
              className="expcatModalCancel"
              style={{ float: "right" }}
              onClick={props.hide}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExpenseCategoryView;
